import * as React from 'react';
import { AccordionDetails as MuiAccordionDetails } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledAccordionDetails = styled(MuiAccordionDetails)({
    backgroundColor: 'white',
    padding: '0px 16px'
});

const AccordionDetails: React.FC<{ children: React.ReactNode }> = props => {
    return <StyledAccordionDetails>{props.children}</StyledAccordionDetails>;
};

export default AccordionDetails;
